import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import isNil from 'lodash/isNil';

import announce from '../../../helpers/announce';
import { NumberTextField } from '../TextField';

function getNumberValue(event) {
    const value = event?.target?.value;

    if (value) {
        const numValue = parseInt(value, 10);
        return numValue;
    }

    return null;
}

export default function Hours({
    hours: hoursNum,
    onChange,
    isInvalid,
    isDisabled,
    isRequired,
    onBlur,
    increment,
    decrement,
    id,
}) {
    const [value, setValue] = useState(hoursNum?.toString() || '');
    const lastCorrectValue = useRef(value);

    useEffect(() => {
        if (!isNil(hoursNum) && hoursNum.toString() !== value) {
            setValue(hoursNum.toString());
            lastCorrectValue.current = hoursNum.toString();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hoursNum]);

    const handleChange = (event) => {
        const numValue = getNumberValue(event);
        const eventValue = event.target.value;

        if (eventValue === '') {
            setValue('');
        } else if (numValue > 12) {
            event.preventDefault();
            const newValue = eventValue[eventValue.length - 1];
            setValue(newValue);
            lastCorrectValue.current = newValue;
            announce(`Adjusted to ${newValue} hours`);
            onChange(parseInt(newValue, 10));
        } else {
            setValue(eventValue);
            lastCorrectValue.current = eventValue;
            onChange(numValue);
        }
    };

    const handleBlur = (event) => {
        const numValue = getNumberValue(event);
        const eventValue = event.target.value;

        if (!eventValue && lastCorrectValue.current) {
            setValue(lastCorrectValue.current);
            onChange(parseInt(lastCorrectValue.current, 10));
        } else if (!numValue && eventValue) {
            setValue('12');
            lastCorrectValue.current = '12';
            onChange(12);
        }
        onBlur();
    };

    const handleKeyDown = (event) => {
        const { key } = event;

        if (key === 'ArrowUp') {
            increment();
        }
        if (key === 'ArrowDown') {
            decrement();
        }
    };

    return (
        <NumberTextField
            isLabelVisible={false}
            label="Hours"
            id={`${id}-hours-input`}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength="2"
            isInvalid={isInvalid}
            isDisabled={isDisabled}
            isRequired={isRequired}
            shouldValidate={false}
            onKeyDown={handleKeyDown}
        />
    );
}

Hours.propTypes = {
    hours: PropTypes.number,
    onChange: PropTypes.func,
    isInvalid: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isRequired: PropTypes.bool,
    onBlur: PropTypes.func,
    increment: PropTypes.func,
    decrement: PropTypes.func,
};
